import React from "react"

import Header from "../components/Header"
import Footer from "../components/Footer"

const FAQ = () => (
  <div>
    <Header showSearch={false} />
    <div className="max-w-7xl mx-auto pt-10">
      <h1 className="text-center text-4xl mb-10">Preguntas Frecuentes</h1>
      <main className="mx-auto" style={{ maxWidth: "70ch" }}>
        <p>
          En esta sección hemos recopilado las respuestas a las preguntas más
          frecuentes.
        </p>
        <dl>
          <dt className="text-xl font-bold my-4">Inscripciones</dt>
          <dd>
            El proceso de inscripción de empresas para participar en el evento
            se realizará entre los días 11 y 22 de Noviembre 2020.
          </dd>
          <dt className="text-xl font-bold my-4">
            Valores de inscripción para Pymes
          </dt>
          <dd>
            Hemos establecido un un valor de inscripción para Pymes de $3.900
            pesos chilenos. Sin embargo, si no tienes los medios para cubrir
            esta inscripción debido a la situación actual, por favor escríbenos
            a través del formulario de contacto para poder ayudarte a
            conseguirte un cupo gratis, gracias a nuestras Startups y Rockstars.
          </dd>
          {/* <dt className="text-xl font-bold my-4">Duración del evento</dt>
                <dd>
                  El evento comienza el 08 de Junio a las 00:00 hrs. y termina
                  el 10 de Junio a las 23:59 hrs.
                </dd> */}
          <dt className="text-xl font-bold my-4">Organizadores del evento</dt>
          <dd>
            Navidad Pyme es organizado por Denda, Symmetrics Lab y Wild Foods,
            ServiSenior y Espacio Riesco.
          </dd>
          <dt className="text-xl font-bold my-4">Páginas caídas</dt>
          <dd>
            Cada empresa pondrá a disposición plataformas de contacto para
            informarte qué hacer en caso de que esto ocurra. También puedes
            comunicarte con nosotros a través de nuestros canales de Facebook e
            Instagram, para derivarte a los canales de las Pymes.
          </dd>
          <dt className="text-xl font-bold my-4">Reclamos</dt>
          <dd>
            Cada empresa se hará cargo de los productos y/o servicios que ofrece
            durante el evento Navidad Pyme, lo que incluye despachos, garantías,
            etc. Para tus reclamos y consultas sobre tu compra, debes dirigirte
            al Servicio al Cliente de la empresa en la cual realizaste la
            transacción.
          </dd>
          <dt className="text-xl font-bold my-4">
            ¿Puedo participar sin haberme inscrito?
          </dt>
          <dd>
            Debido a que este es un evento para ayudar a las Pymes, si quieres
            participar y usar el nombre del evento, lo puedes hacer sin ningún
            problema y para ayudarte, hemos creado un &quot;Kit de
            Herramientas&quot; para mejorar tus publicaciones en Redes Sociales
            y E-Mail Marketing. Descargalo en la sección &quot;Material
            gráfico&quot; de nuestro sitios.
          </dd>
        </dl>
      </main>
    </div>
    <Footer />
  </div>
)

export default FAQ
